<app-dashboard>
  <div class="w-full flex flex-col p-[20px]">
    <div class="w-full flex justify-end">
      <div *ngIf="canWrite" class="w-full max-w-[200px]">
        <app-dropdown
          [items]="createRelayTypes"
          [placeholder]="'Add Relay'"
          (selectedValue)="navigateToCreate($event)"
        />
      </div>
      <div *ngIf="!canWrite" class="w-full h-[30px]"></div>
    </div>
    <div class="border-b flex gap-[15px]">
      <div
        *ngFor="let type of relayType"
        (click)="setRelayType(type)"
        class="transition-all duration-300 ease-in-out flex flex-col gap-[3px] cursor-pointer"
      >
        <span
          class="px-[10px] font-[700] {{
            currentRelayType === type ? 'text-[#081A46]' : 'text-slate-500'
          }}"
          >{{ type }}</span
        >
        <div
          *ngIf="currentRelayType === type"
          class="h-[2px] rounded-t-[2px] bg-[#081A46] w-full"
        ></div>
      </div>
    </div>
    <div class="w-full">
      <div
        class="transition-all duration-300 ease-in-out p-[20px]"
      >
        <app-table
          [tableData]="tableData"
          [tableHeader]="tableHeader"
          (rowClick)="openRelayDetails($event)"
          [tableTitle]="'Transactions'"
          [loading]="fetchingData"
          [emptyState]="emptyTableState"
          [filterData]="filterData"
          (handleFilter)="applyFilter($event)"
          (handleSearch)="search($event)"
          [tableWidth]="' min-w-[990px]'"
          [toolbar]="{
            paginate: true,
            search: true,
            filter: true,
            addnew: false
          }"
          [paginationData]="{
            limit: limit,
            totalData: totalRelays
          }"
          (changeLimit)="changeLimit($event)"
        >
          <div class="flex justify-end items-center sm:w-full">
            <app-pagination
              *ngIf="!fetchingData && this.totalRelays > 0"
              [totalItems]="this.totalRelays"
              [(pageSize)]="this.limit"
              [(currentPage)]="this.page"
              (pageSizeChange)="this.refreshList()"
              (currentPageChange)="this.getRelays()"
            ></app-pagination>
          </div>
        </app-table>
      </div>
      <!-- <div
        *ngIf="currentRelayType === 'Inbound'"
        class="transition-all duration-300 ease-in-out p-[20px]"
      >
        <span>Inbound</span>
      </div> -->
      <!-- <div
        *ngIf="currentRelayType === 'Outbound'"
        class="transition-all duration-300 ease-in-out p-[20px]"
      >
        <span>Outbound</span>
      </div> -->
    </div>
  </div>
</app-dashboard>
<app-side-modal
  [title]="'Relay Details'"
  [isOpen]="relayDetailsOpen"
  (closeModalEvent)="closeRelayDetails()"
>
  <div class="w-full">
    <div class="flex overflow-y-auto flex-col w-full gap-[10px]">
      <div class="w-full flex flex-col gap-[2px] border-b pb-[10px]">
        <div class="flex items-end gap-[10px]">
          <span class="text-[22px] font-[600] text-slate-800">{{
            singleRelay?.name
          }}</span>
          <div (click)="copyText(singleRelay?._id)" class="flex gap-[5px] items-center mb-[3px] cursor-pointer">
            <span class="text-[12px] font-[400] text-slate-600">{{
              singleRelay?._id
            }}</span
            ><img
              class="w-[12px]"
              src="../../../assets/icons/copy-text.svg"
              alt=""
            />
          </div>
        </div>
        <div class="flex items-center gap-[3px]">
          <img src="../../../assets/icons/clock-icon.svg" alt="" />
          <span class="text-[12px] font-[400] text-slate-400"
            >2025-01-17T09:16:47.324Z</span
          >
        </div>
      </div>
      <div class="w-full flex items-center justify-between border-b pb-[5px]">
        <span class="text-[11px] text-[#6B7280] font-[500]"
          >Destination Domain:</span
        >
        <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{
          singleRelay?.destinationDomain
        }}</span>
      </div>
      <div class="w-full flex items-center justify-between border-b pb-[5px]">
        <span class="text-[11px] text-[#6B7280] font-[500]">Source IP(s):</span>
        <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{
          singleRelay?.sourceIp
        }}</span>
      </div>
      <div class="w-full flex items-center justify-between border-b pb-[5px]">
        <span class="text-[11px] text-[#6B7280] font-[500]">Relay Type:</span>
        <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{
          singleRelay?.type
        }}</span>
      </div>
      <div
        *ngIf="this.singleRelay?.filters.length > 0"
        class="w-full px-[8px] flex flex-col gap-[10px]"
      >
        <span class="text-[16px] font-[600] text-slate-600">Filters:</span>
        <div
          *ngFor="let filter of singleRelay?.filters"
          class="w-full flex flex-col gap-[10px] items-center justify-between pb-[5px]"
        >
        <div class="w-full flex items-center justify-between border-b pb-[5px]">
          <span class="text-[11px] text-[#6B7280] font-[500]">Action:</span>
          <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{
            filter?.action
          }}</span>
        </div>
        <div class="w-full flex items-center justify-between border-b pb-[5px]">
          <span class="text-[11px] text-[#6B7280] font-[500]">Type:</span>
          <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{
            filter?.type
          }}</span>
        </div>
        <div class="w-full flex items-center justify-between border-b pb-[5px]">
          <span class="text-[11px] text-[#6B7280] font-[500]">Storage Type:</span>
          <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{
            filter?.storage
          }}</span>
        </div>
        <div class="w-full flex items-center justify-between border-b pb-[5px]">
          <span class="text-[11px] text-[#6B7280] font-[500]">Token Generator:</span>
          <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{
            filter?.tokenGenerator
          }}</span>
        </div>
        <div class="w-full flex items-center justify-between border-b pb-[5px]">
          <span class="text-[11px] text-[#6B7280] font-[500]">Targets:</span>
          <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{
            filter?.targets
          }}</span>
        </div>
        <div class="w-full flex items-center justify-between border-b pb-[5px]">
          <span class="text-[11px] text-[#6B7280] font-[500]">Transformer:</span>
          <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{
            filter?.transformer
          }}</span>
        </div>
        <div *ngIf="filter?.transformerSelections.length > 0" class="w-full flex flex-col gap-[10px]">
          <span class="text-[16px] font-[600] text-slate-800">Transformer Selections:</span>
          <div *ngFor="let selection of filter?.transformerSelections">
            <div class="w-full flex items-center justify-between border-b pb-[5px]">
              <span class="text-[11px] text-[#6B7280] font-[500]">{{selection?.type}}:</span>
              <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{
                selection?.selector
              }}</span>
            </div>
          </div>
        </div>
        <div *ngIf="filter?.config?.rules.length > 0" class="w-full flex flex-col gap-[10px] px-[10px]">
          <span class="text-[16px] font-[600] text-slate-800">Config:</span>
          <div class="w-full flex items-center justify-between border-b pb-[5px]">
            <span class="text-[11px] text-[#6B7280] font-[500]">Condition:</span>
            <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{
              filter?.config?.condition
            }}</span>
          </div>
          <div class="w-full flex flex-col gap-[10px] mb-[20px]"> 
            <div class="w-full grid grid-cols-4 gap-[5px]">
              <span class="text-[11px] text-[#6B7280] font-[500]">Field</span>
              <span class="text-[11px] text-[#6B7280] font-[500]">Operator</span>
              <span class="text-[11px] text-[#6B7280] font-[500]">Type</span>
              <span class="text-[11px] text-[#6B7280] font-[500]">Value</span>
            </div>
            <div *ngFor="let rule of filter?.config?.rules" class="w-full grid grid-cols-4 gap-[5px]">
              <span class="text-[13px] text-[#1F2937] font-[600] capitalize">{{rule?.field}}</span>
              <span class="text-[13px] text-[#1F2937] font-[600] capitalize">{{rule?.operator}}</span>
              <span class="text-[13px] text-[#1F2937] font-[600] capitalize">{{rule?.type}}</span>
              <span class="text-[13px] text-[#1F2937] font-[600] capitalize">{{rule?.value}}</span>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="w-full flex flex-col gap-[15px]">
     <div *ngIf="canUpdate" class="w-full">
      <app-button
      [label]="'Edit Relay'"
      (onClick)="navigateToEdit(singleRelay?._id)"
      [className]=" 
        'text-[#081A46] w-full h-[50px] flex items-center whitespace-nowrap border-[1px] justify-center cursor-pointer rounded-[10px] bg-[#fff] border-[#081A46] cursor-pointer'
      "
    ></app-button>
     </div>
   <div *ngIf="canDelete" class="w-full">
    <app-button
    [label]="'Delete Relay'"
    (onClick)="openDeleteModal(singleRelay?._id)"
    [className]="
      'text-[#FF0000] w-full h-[50px] flex items-center whitespace-nowrap border-[1px] justify-center cursor-pointer rounded-[10px] bg-[#fff] border-[#FF0000] cursor-pointer'
    "
  ></app-button>
   </div>
    </div>
  </div>
</app-side-modal>

<app-modal
  [title]="'Create New API Key'"
  [isOpen]="deleteModalOpen"
  (closeModalEvent)="closeDeleteModal()"
>
  <div class="flex flex-col w-full gap-[30px] items-center">
    <span class="text-slate-800 text-[14px]">Delete this Relay?</span>
    <div class="w-full flex justify-end">
      <!-- <app-button
        [label]="'Close Modal'"
        (onClick)="closeDeleteModal()"
        [className]="
          'text-[#081A46] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] border border-[#081A46]'
        "
      ></app-button> -->
      <app-button
        [label]="'Delete Key'"
        (onClick)="deleteRelay()"
        [loading]="loading"
        [className]="
          'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
        "
      ></app-button>
    </div>
  </div>
</app-modal>

<!-- <app-button
[label]="'Invite Member'"
(onClick)="canWrite ? openCreateModal() : null"
[className]="
        'text-[#fff] max-w-[150px] w-full h-[50px] flex items-center whitespace-nowrap justify-center rounded-[5px] ' + (canWrite ? 'bg-[#081A46] cursor-pointer' : 'bg-gray-600 cursor-not-allowed')
      "
[isDisabled]="canWrite"
></app-button> -->
